import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex min-h-0 flex-1" }

import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/holiday-pay-obligations-entries';
    import { computed, watch } from 'vue';
    import { Head, router } from '@inertiajs/vue3';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import HolidayPayObligationsTableExport from '@/components/holiday-pay-obligations/HolidayPayObligationsTableExport.vue';
    import PageCard from '@/components/PageCard.vue';
    import PayrollSummary from '@/components/salary/PayrollSummary.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { SharedData, BreadcrumbItem, Company, HolidayPayObligation } from '@/types';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditHolidayPayObligation',
  props: {
    obligation: {},
    hasDepartments: {},
    company: {}
  },
  setup(__props: any) {

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { t } = useI18n();

    const { hasPermission } = usePermissions();

    const props = __props;

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'dashboards.payroll',
        },
        {
            title: 'holiday-pay-obligations.page_header',
            href: route('v2.salary.holiday-pay-obligations.index'),
        },
        {
            title: props.company.name,
            translated: true,
        },
    ];

    watch(selectedCompanyId, (newCompanyId, oldCompanyId) => {
        if (newCompanyId !== oldCompanyId && oldCompanyId !== undefined) {
            router.visit(route('v2.salary.holiday-pay-obligations.index'));
        }
    });

    const { isPending, data } = useQuery({
        queryKey: [
            QueryKey.HOLIDAY_PAY_OBLIGATIONS_ENTRIES,
            props.obligation.payroll_id,
            props.obligation.company_id,
        ],
        queryFn: getHolidayPayObligationEntries,
        placeholderData: [],
    });

    async function getHolidayPayObligationEntries() {
        const { data } = await axios.get(
            route('v2.salary.holiday-pay-obligations.entries.get', {
                companyId: selectedCompanyId.value,
                id: props.obligation.payroll_id,
            }),
        );
        return data.data;
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Head), {
      title: _unref(t)('holiday-pay-obligations.entries.page_header')
    }, null, 8, ["title"]),
    _createVNode(AppLayout, { breadcrumbs: breadcrumbs }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(PageCard, { class: "min-w-0 flex-1" }, {
            default: _withCtx(() => [
              _createVNode(DataTable, {
                "table-key": _unref(QueryKey).HOLIDAY_PAY_OBLIGATIONS_ENTRIES,
                columns: _unref(columns),
                data: _unref(data),
                loading: _unref(isPending),
                "enable-search": false,
                "enable-filters": false,
                "default-column-visibility": {
                        id: false,
                        days_outstanding: !!props.hasDepartments,
                    },
                "default-sorting": [
                        {
                            id: 'employee_name',
                            desc: false,
                        },
                    ]
              }, {
                title: _withCtx(() => [
                  _createVNode(_unref(CardTitle), null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('holiday-pay-obligations.entries.page_header')), 1)
                    ]),
                    _: 1
                  })
                ]),
                actions: _withCtx(() => [
                  _createVNode(DataTableToolbarActions, { name: "holiday-pay-obligations" }, {
                    default: _withCtx(() => [
                      (_unref(hasPermission)(_unref(Permission).HOLIDAY_PAY_OBLIGATIONS_UPDATE))
                        ? (_openBlock(), _createBlock(HolidayPayObligationsTableExport, {
                            key: 0,
                            "holiday-pay-obligation": _ctx.obligation
                          }, null, 8, ["holiday-pay-obligation"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["table-key", "columns", "data", "loading", "default-column-visibility"])
            ]),
            _: 1
          }),
          _createVNode(PayrollSummary, {
            payroll: _ctx.obligation,
            "show-badge": false
          }, null, 8, ["payroll"])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})